<template>
  <div class="animated fadeIn">
    <b-overlay :show="loading">
      <div v-if="!loading">
        <iframe
          v-if="type === 'application/pdf'"
          ref="iframe"
          type="application/pdf"
          border="0"
          class="w-100 border"
          style="height: 800px"
          :src="url"
        >
        </iframe>
        <div v-if="editor_mime_type.includes(type) && contents">
          <prism-editor
            class="code-editor"
            v-model="contents"
            :highlight="highlighter"
            line-numbers
            readonly
          ></prism-editor>
        </div>
      </div>
      <div v-if="loading" class="py-5"></div>
    </b-overlay>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import ResultDocumentModel from "@/models/modus/ResultDocumentModel";
import DocumentModel from "@/models/document/DocumentModel";
import ResultModel from "@/models/modus/ResultModel";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-xml-doc";
import "prismjs/themes/prism-tomorrow.css";
import xml_formatter from "xml-formatter";

export default {
  components: {
    BasicHeading,
    PrismEditor,
  },
  name: "ResultDocumentDetail",
  props: ["manual_document"],
  data() {
    return {
      loading: true,
      result_id: this.$route.params.result_id || this.pass_result_id,
      result_document_id:
        this.$route.params.result_document_id || this.pass_result_document_id,
      result: null,
      result_document: null,
      document: null,
      type: null,
      contents: null,
      url: null,
      editor_mime_type: ["text/xml", "application/xml"],
    };
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.xml);
    },
  },
  watch: {
    manual_document: {
      handler() {
        this.document = this.manual_document;
      },
      immediate: true,
    },
    document: {
      handler() {
        this.loading = true;
        this.document.file().then(({ response }) => {
          this.contents = response.data;
          this.type = this.document.mime_type;
          if (this.type === "application/pdf") {
            let file = new Blob([this.contents], { type: "application/pdf" });
            this.url = window.URL.createObjectURL(file);
          } else if (this.editor_mime_type.includes(this.type)) {
            this.contents = xml_formatter(this.contents);
          }
          this.loading = false;
        });
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.manual_document) {
      let result = new ResultModel({ id: this.result_id });
      let result_document = new ResultDocumentModel({
        id: this.result_document_id,
      });
      Promise.all([result.fetch(), result_document.fetch()]).then(() => {
        this.result = result;
        this.result_document = result_document;
        let document = new DocumentModel({ id: result_document.document_id });
        document.fetch().then(() => {
          this.document = document;
          document.file().then(({ response }) => {
            let data = response.data;
            let type = document.mime_type;
            if (type.includes("xml")) {
              type = "";
            }
            let file = new Blob([data], { type: type });
            let url = window.URL.createObjectURL(file);
            this.$refs.iframe.src = url;
            this.loading = true;
          });
        });
      });
    } else {
      if (this.url) {
        this.$refs.iframe.src = this.url;
      }
    }
  },
};
</script>
<style>
/* required class */
.code-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #f2f2f2;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>
